import i18n from "@/plugins/i18n"

export const CONTRAGENT_STATUSES = {
    REGISTERED: { code: 1, label: 'Зарегистрирована' },
    BLOCKED: { code: 2, label: 'Заблокирована' }
};

export const USER_STATUSES = {
    AUTHORIZED: { code: 1, label: i18n.global.t('Активный') },
    DELETED: { code: 2, label: i18n.global.t('Удален') },
    BLOCKED: { code: 3, label: i18n.global.t('Заблокирован') }
};

/**
 * Получить текстовое название статуса.
 *
 * @param statusCode Код статуса.
 * @returns {string}
 */
export function getStatusLabel(statusCode) {
    return i18n.global.t(Object.values(CONTRAGENT_STATUSES).find(status => status.code === statusCode).label || 'Неизвестный статус');
}

/**
 * Получить статус.
 *
 * @param statusCode Код статуса.
 * @returns {boolean}
 */
export function getStatus(statusCode) {
    return statusCode === CONTRAGENT_STATUSES.REGISTERED.code;
}